import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/data";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="June 2026">
      <p className="text-white/60 font-light leading-relaxed text-[15px]">
        These Terms &amp; Conditions ("Terms") govern your access to and use of the website, services, and
        vehicle rentals offered by <strong className="text-white">{COMPANY.legalName}</strong> ("Auto-Hire STL,"
        "we," "us," or "our"). By accessing this website, submitting a booking request, or renting a vehicle
        from us, you agree to be bound by these Terms.
      </p>

      <LegalSection heading="1. Eligibility">
        <p>To rent a vehicle you must be at least 21 years of age, hold a valid, unexpired driver's license,
        provide a major credit or debit card in your name, and carry valid automobile insurance. We reserve
        the right to refuse service at our sole discretion.</p>
      </LegalSection>

      <LegalSection heading="2. Bookings & Reservations">
        <p>Submitting a booking request through this website does not constitute a confirmed reservation. All
        requests are subject to vehicle availability and confirmation by Auto-Hire STL. We will contact you to
        confirm availability, pricing, and pickup or delivery details.</p>
      </LegalSection>

      <LegalSection heading="3. Rates, Fees & Payment">
        <p>Rental rates are quoted at the time of booking and may include mileage limits as described for each
        plan. Additional charges may apply for excess mileage, fuel, tolls, citations, cleaning, late returns,
        or damage. You authorize us to charge your payment method for all amounts due under your rental agreement.</p>
      </LegalSection>

      <LegalSection heading="4. Use of Vehicle">
        <p>You agree to operate the rental vehicle lawfully and responsibly. The vehicle may not be used to:
        transport illegal goods; tow or push another vehicle; participate in any race or contest; be driven by
        any unauthorized driver; or be operated by anyone under the influence of alcohol, drugs, or any substance
        impairing the ability to drive. The vehicle may not leave the State of Missouri without prior written
        consent.</p>
      </LegalSection>

      <LegalSection heading="5. Insurance & Liability">
        <p>You are responsible for the vehicle during the rental period. You agree to maintain insurance coverage
        as required by Missouri law. To the maximum extent permitted by law, Auto-Hire STL is not liable for any
        indirect, incidental, or consequential damages arising from your use of a rental vehicle or this website.</p>
      </LegalSection>

      <LegalSection heading="6. Cancellations">
        <p>Cancellation and modification policies will be communicated at the time your reservation is confirmed.
        Please contact us as early as possible if your plans change.</p>
      </LegalSection>

      <LegalSection heading="7. Damage, Loss & Return">
        <p>You agree to return the vehicle in the same condition in which it was received, ordinary wear excepted.
        You are responsible for loss or damage to the vehicle during the rental period, including theft, regardless
        of fault, subject to applicable insurance.</p>
      </LegalSection>

      <LegalSection heading="8. Communications Consent (SMS & Email)">
        <p>By submitting a booking or contact request, you consent to receive transactional communications from us
        by SMS text message and email regarding your request, including confirmations and follow-ups. Message and
        data rates may apply. You may opt out of non-essential messages at any time by contacting us.</p>
      </LegalSection>

      <LegalSection heading="9. Intellectual Property">
        <p>All content on this website, including logos, text, graphics, and the "Ride With Us" mark, is the
        property of {COMPANY.legalName} and may not be reproduced without written permission.</p>
      </LegalSection>

      <LegalSection heading="10. Governing Law">
        <p>These Terms are governed by the laws of the State of Missouri, without regard to its conflict-of-law
        provisions. Any dispute shall be resolved in the state or federal courts located in St. Louis, Missouri.</p>
      </LegalSection>

      <LegalSection heading="11. Changes to These Terms">
        <p>We may update these Terms from time to time. Continued use of the website or our services after changes
        are posted constitutes acceptance of the revised Terms.</p>
      </LegalSection>

      <LegalSection heading="12. Contact">
        <p>{COMPANY.legalName}<br />
        {COMPANY.address}<br />
        Phone: <a href={COMPANY.phoneHref} className="text-[#F2B705]">{COMPANY.phone}</a><br />
        Email: <a href={`mailto:${COMPANY.email}`} className="text-[#F2B705]">{COMPANY.email}</a></p>
      </LegalSection>
    </LegalLayout>
  );
}
